export default __webpack_public_path__ + "static/media/b1.32e9db0b.png";